import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  banner: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '12px',
    rowGap: '8px',
    padding: '8px 12px',
    marginBottom: '16px',
    borderRadius: '8px',
    border: '1px solid rgba(0, 146, 153, 0.35)',
    backgroundColor: 'rgba(0, 146, 153, 0.06)',
    flexWrap: 'wrap'
  },
  icon: {
    display: 'inline-flex',
    // Only decoration: on a phone the address needs the width more.
    '@media (max-width: 599px)': {
      display: 'none'
    }
  },
  bannerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: 0,
    flex: '1 1 320px'
  },
  // Inline, not flex: a long address wraps inside its line and the copy button follows its last character.
  addressRow: {
    minWidth: 0
  },
  label: {
    fontSize: '13px',
    opacity: 0.75,
    whiteSpace: 'nowrap',
    marginRight: '8px'
  },
  // Breaks at its hyphens where it must, and inside a word only when a part is still too long.
  address: {
    fontFamily: 'monospace',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    overflowWrap: 'anywhere'
  },
  copy: {
    '&.MuiButton-root': {
      marginLeft: '6px',
      verticalAlign: 'middle',
      minWidth: 0,
      width: '28px',
      height: '28px',
      padding: 0
    }
  },
  hint: {
    fontSize: '13px',
    opacity: 0.75
  }
}));
export default useStyles;